import React from 'react'
import { Col, Row } from 'reactstrap'

const Layout: React.FC<{ [label: string]: any }> = (props: any) => {
    return <div>
        {
            screen.width >= 768 ?
                // COLUMNS SIDE BY SIDE
                <div style={{ width: '100%', margin: '0px', flexDirection: 'row', display: 'flex' }}>
                    <div style={{ paddingBottom: '25px', width: '37.5%', paddingRight: 15 }}>
                        {props.leftCol}
                    </div>
                    <div style={{ paddingBottom: '25px', width: '62.5%', paddingLeft: 15 }}>
                        {props.rightCol}
                    </div>
                </div>
                :
                // COLUMNS STACKED
                <div>
                    <Row style={{ width: '100%', margin: '0px' }}>
                        <Col style={{ width: '100%', paddingBottom: '25px' }}>
                            {props.leftCol}
                        </Col>
                    </Row>
                    <Row style={{ width: '100%', margin: '0px' }}>
                        <Col style={{ width: '100%', paddingBottom: '25px' }}>
                            {props.rightCol}
                        </Col>
                    </Row>
                </div>
        }
    </div>
}

export default Layout


// WEBPACK FOOTER //
// ./src/components/misc/Layout.tsx